/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

import applyTreeSelectionCommitToState from './helpers/applyTreeSelectionCommitToState';
import createTreeSelectionThunk from './helpers/createTreeSelectionThunk';
import { getVariantTogglePlan } from './helpers/treeSelection';
import { MASTER_SELECTION_CONTEXT } from './helpers/selectionContext';
import { buildSelectionKey } from './helpers/selectionKey';

export const selectTreeVariantCommit = createAction('products/selectTreeVariant/commit');

export const selectTreeVariant = createTreeSelectionThunk(
  'products/selectTreeVariant',
  selectTreeVariantCommit,
);

export const reducer = (builder) => {
  builder.addCase(selectTreeVariantCommit, (state, { payload }) => {
    const { variant, value = true, keepChannelSelection } = payload;
    const plan = getVariantTogglePlan(variant, value, state.ui.selection);
    applyTreeSelectionCommitToState(state, {
      ...plan,
      context: MASTER_SELECTION_CONTEXT,
      lastClickedKey: buildSelectionKey({ type: 'masterVariant', _id: variant._id }),
      keepChannelSelection,
      source: 'tree',
    });
  });
};
